const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

function initializeMenu() {
  const toggle = document.querySelector('[data-menu-toggle]')
  const menu = document.querySelector('[data-mobile-menu]')
  if (!toggle || !menu) return
  const setOpen = (open) => {
    toggle.classList.toggle('is-open', open)
    toggle.setAttribute('aria-expanded', String(open))
    menu.hidden = !open
  }
  toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'))
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)))
}

function initializeHeader() {
  const header = document.querySelector('[data-site-header]')
  if (!header) return
  const update = () => header.classList.toggle('is-scrolled', window.scrollY > 12)
  update()
  window.addEventListener('scroll', update, { passive: true })
}

function initializeQuantityControl() {
  const input = document.querySelector('[data-ws-qty-for]')
  const minus = document.querySelector('[data-quantity-minus]')
  const plus = document.querySelector('[data-quantity-plus]')
  if (!(input instanceof HTMLInputElement)) return
  const value = () => Math.max(1, Number.parseInt(input.value, 10) || 1)
  const max = () => Math.max(1, Number.parseInt(input.max, 10) || Number.MAX_SAFE_INTEGER)
  minus?.addEventListener('click', () => { input.value = String(Math.max(1, value() - 1)) })
  plus?.addEventListener('click', () => { input.value = String(Math.min(max(), value() + 1)) })
  input.addEventListener('change', () => { input.value = String(Math.min(max(), value())) })
}

function initializeCartToast() {
  const toast = document.querySelector('[data-cart-toast]')
  if (!(toast instanceof HTMLElement)) return
  let timeout
  document.addEventListener('storefront:added', () => {
    window.clearTimeout(timeout)
    toast.hidden = false
    if (!prefersReducedMotion.matches) toast.animate([{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'cubic-bezier(.2,.8,.2,1)' })
    timeout = window.setTimeout(() => { toast.hidden = true }, 4200)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initializeMenu()
  initializeHeader()
  initializeQuantityControl()
  initializeCartToast()
})
